///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.new_customer_matching = abcsetup.new_customer_matching || {};
abcsetup.new_customer_matching.events = abcsetup.new_customer_matching.events || {};
abcsetup.new_customer_matching.events.award = abcsetup.new_customer_matching.events.award || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.new_customer_matching.events.award.edit = {

    // Array to store the match_ids than can be acted upon
    match_ids: [],

    // Map of award status to select option value
    award_map: {
        'award': 'awarded',
        'counter': 'countered',
        'decline': 'declined',
    },

    init: function () {
        const _this = this;

        $("#app_data_tables_new_customer_matching_item_match_data_table").on('draw.dt', function () {
            _this.match_ids = [];
            $('.match_id').not('.disabled').each(function () {              
                _this.match_ids.push(parseInt($(this).val(), 10));
            });
        });

        // Validate the input file
        $(document).on("change", "#award-status-import-file", function (e) {
            _this.validateInputFile($(this));
        });

        // Toggle the submit button to only be enabled if a status is selected
        $(document).on("change", 'select.award-status', function (e) {
            const id = $(this).data('id');
            const current_bid = $('#current_bid_'+id);
            const target_price = $('#target_price_'+id);
            const row = $(this).closest('tr');

            row.removeClass('table-warning table-success table-danger');
            window.fieldValidate.resetValidation(current_bid);
            window.fieldValidate.resetValidation(target_price);
            target_price.prop('readonly', true);

            if ($(this).val() === 'awarded') {
                current_bid.val(current_bid.data('original-value'));
                row.addClass('table-success');
            } else if ($(this).val() === 'countered') {
                target_price.prop('readonly', false);
                if (isNaN(target_price.val()) || target_price.val() <= 0) {
                    target_price.addClass('invalid').trigger('change');
                }
                row.addClass('table-warning');
            } else if ($(this).val() === 'declined') {
                row.addClass('table-danger');
            }

            _this.toggleAwardStatusButton();
        });

        // Toggle the submit button to only be enabled if a status is selected
        $(document).on("change", 'input.target-price', function (e) {
            if ($(this).val().length > 0) {
                $('#award_'+$(this).data('id')).val('countered').trigger('change');
            }
            
            _this.toggleAwardStatusButton();
        });

        // Reset the import form
        $(document).on("click", '#reset-import', function (e) {
            $('select.award-status').not(':disabled').each(function () {
                $(this).val('').trigger('change');
                $('#target_price_'+$(this).data('id')).val('').trigger('change').prop('readonly', true);
            });

            $('#import-error-modal').modal('hide');   
        });
    },

    toggleAwardStatusButton: function (match_id) {
        $('#update-award-statuses').prop('disabled', true);
        const invalid_bids = ($('input.form-control.invalid').length > 0);

        $('select.award-status').not(':disabled').each(function () {
            if ($(this).val() !== '' && !invalid_bids) {
                $('#update-award-statuses').prop('disabled', false);
            }
        });
    },

    validateInputFile: function (fileInput) {
        const _this = this;
        let file = fileInput[0];
        let errors = [];
        let changes = [];

        if (file.files.length > 0) {    
            const column_map = [
                'imported_customer_item',
                'cencora_8_digit_sap',
                'imported_item_description',
                'imported_upc',
                'imported_ndc',
                'imported_mfg_part',
                'imported_brand_reference',
                'imported_band_required?',
                'imported_pkg_size',
                'imported_pkg_uom',
                'imported_incremental_volume_opportunity',
                'imported_category',
                'bid_category_manager',
                'bid_sap_supplier',
                'bid_supplier_name',
                'bid_upc',
                'cencora_8-digit_sap_#',
                'item_description',
                'bid_pkg_size',
                'current_bid',
                'award_status',
                'counter_price',
                'status',
                'match_id'
            ];

            abcsetup.blockUI(true);
            abcsetup.excel.readFile(file, function(data) {
                let rows = abcsetup.excel.toArray(data, column_map);
                
                for (i in rows) {
                    let match_id = parseInt(rows[i].match_id, 10);

                    if (_this.match_ids.indexOf(match_id) === -1) {
                        continue;
                    }

                    let lineno = (parseInt(i, 10)+2);
                    let award_status = '';
                    let current_bid = parseFloat(rows[i].current_bid);
                    let counter_price = parseFloat(rows[i].counter_price);

                    // Correct and set the award status
                    if (_this.award_map.hasOwnProperty(rows[i].award_status.toLowerCase())) {
                        award_status = _this.award_map[rows[i].award_status.toLowerCase()];
                        changes.push(match_id);
                    }

                    $('#award_'+match_id).val(award_status).trigger('change');

                    // Validation around counter offers
                    if (award_status === 'countered') {
                        $('#target_price_'+match_id).val(counter_price).trigger('change');

                        if (isNaN(counter_price) || counter_price <= 0) {
                            $('#target_price_'+match_id).addClass('invalid').trigger('change');
                            errors.push('<li>Line ' + lineno + ': indicates a counter but no valid counter price was provided.</li>');
                        }
                    }
                }

                abcsetup.unblockUI();
                fileInput.val('');

                if (errors.length > 0) {
                    //abcsetup.alerts.show('Import Errors', errors.join('<br>'));
                    $('#import-error-list').html(errors.join(''));
                    $('#import-error-modal').modal('show');
                } else if (changes.length < 1) {
                    abcsetup.alerts.show('Import Warning', 'No changes were made to the award statuses. Please review the file and try again.');
                } else {
                    abcsetup.alerts.show('Import Successful', 'File uploaded successfully. Click "Update Award Statuses" to save changes.');
                }

            }, true);
        }
    },
}